"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertCredentialDescriptor = exports.getCredential = exports.createCredential = void 0;
const tslib_1 = require("tslib");
const errors_1 = require("./errors");
const encoding_1 = require("./encoding");
const createCredential = (options) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    try {
        const credential = yield navigator.credentials.create(options);
        if (credential !== null) {
            return credential;
        }
    }
    catch (e) {
        throw new errors_1.NavigatorError();
    }
    throw new errors_1.NavigatorError();
});
exports.createCredential = createCredential;
const getCredential = (options) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    try {
        const credential = yield navigator.credentials.get(options);
        if (credential !== null) {
            return credential;
        }
    }
    catch (e) {
        throw new errors_1.NavigatorError();
    }
    throw new errors_1.NavigatorError();
});
exports.getCredential = getCredential;
const convertCredentialDescriptor = (credential) => {
    const desc = {
        id: encoding_1.base64ToBuffer(credential.id),
        type: credential.type,
    };
    if (credential.transports) {
        desc.transports = credential.transports;
    }
    return desc;
};
exports.convertCredentialDescriptor = convertCredentialDescriptor;
//# sourceMappingURL=navigator.js.map